export default __webpack_public_path__ + "static/media/1344.14d33d67.png";